<mat-form-field appearance="outline">
  <mat-label>{{ label ?? name }}</mat-label>
  <mat-select [formControlName]="name" [multiple]="multiple">
    @for (item of datasource; track item) {
      <mat-option #matOption [value]="item.Id">{{ item.Name | translate }}</mat-option>
    }
  </mat-select>
  @if (description) {
    <mat-hint>
      <mat-icon>info</mat-icon>
      {{ description }}
    </mat-hint>
  }
</mat-form-field>